// import external dependencies
import 'jquery';
import 'jquery-ui';
import 'slick-carousel';
import 'jquery-match-height'
require('bootstrap');
import Swiper, { Autoplay, Navigation } from 'swiper';
Swiper.use([Autoplay, Navigation]);

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateAtoz from './routes/templateAtoz';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  templateAtoz,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(($) => {
  blockSelect();
  formFilterReset();
});

function formFilterReset() {
  const $form = $('.js-form-filter');

  if ( $form.length ) {
    $form.find( '.js__reset' ).on( 'click', function() {
      const $this   = $(this);
      const $parent = $this.parents( '.js-form-filter' );

      $parent.find( '.js-block-select .js__counter' ).text( '0' );

      $form.find( '[checked]' ).removeAttr( 'checked' );
      $form.find( 'input' ).prop( 'checked', false );
      $form.find( 'form' ).submit();
    });
  }
}

function blockSelect() {
  const $select = $('.js-block-select');

  if ( $select.length ) {
    const $body = $('body');
    let _timer  = null;

    $select.on( 'change', 'input', function() {
      checkSelectBlocks();
    });

    $select.find( 'label' ).on( 'mouseup', function( event ) {
      event.preventDefault();
      event.stopPropagation();

      clearTimeout(_timer);

      const $this    = $(this);
      const $parent  = $this.parents( '.js-block-select' );
      const $counter = $parent.find( '.js__counter' );

      let _counter = 0;

      _timer = setTimeout(function() {
        $parent.find( 'input' ).each( function() {
          const $input = $(this);

          if ( $input.prop('checked') ) {
            _counter = _counter + 1;
          }
        });

        $counter.text( _counter );
      }, 450);
    });

    $select.find( '.js__all' ).on( 'click', function( event ) {
      event.preventDefault();

      const $this    = $(this);
      const $parent  = $this.parents( '.js-block-select' );
      const $counter = $parent.find( '.js__counter' );

      let _counter = 0;

      $this.toggleClass( 'active' );

      if ( $this.hasClass( 'active' ) ) {
        $parent.find( 'input' ).each( function() {
          $(this).prop( 'checked', true );

          _counter = _counter + 1;
        });

        $counter.text( _counter );
      } else {
        $parent.find( 'input' ).each( function() {
          $(this).prop( 'checked', false );
        });

        $counter.text( '0' );
      }

      checkSelectBlocks();
    });
  }
}

function checkSelectBlocks() {
  const $select = $('.js-block-select');

  if ( ! $select.length ) {
    return false;
  }

  $select.each( function() {
    const $thisSelect = $(this);
    const $title      = $thisSelect.find( '.js__title > p' );
    const _emptyTitle = $thisSelect.find( '.js__title' ).attr( 'data-title' );

    let _title = false;

    $thisSelect.find( 'input' ).each( function() {
      const $input     = $(this);
      const _label     = $input.next().text();
      const _isChecked = $input.prop( 'checked' );

      if ( _isChecked ) {
        _title = ( _title == false ) ? _label : _title + ', ' + _label;
      }
    });

    if ( _title != false ) {
      $title.text( _title );
    } else {
      $title.text( _emptyTitle );
    }
  });
}

jQuery(document).ready(($) => {
  // if ( $( '#celebrate' ).length ) {
  //   $( 'body' ).addClass( 'is-celebrate-popup' );
  // }

  // $( '#celebrate' ).on( 'click', '.close', function( event ) {
  //   event.preventDefault();

  //   $(this).parents( '#celebrate' ).remove();
  //   $( 'body' ).find( '#mainNav' ).removeClass( 'celebrate' );
  //   $( 'body' ).removeClass( 'is-celebrate-popup' );
  // });

  // $( '.nav-icon' ).on( 'click', function( event ) {
  //   event.preventDefault();

  //   $('body').toggleClass( 'navOpen' );
  // });

  $('[data-region]').on('click', function() {
    let region = $(this).data('region');
    $('select[name="region"]').val(region);
  });
  $('.slideout-contact-form input[name="reference"]').val(Date.now());

  $('[data-slideout-close], [data-project-slideout-overlay]').on('click', function(e) {
    e.preventDefault();
    $('[data-project-slideout-overlay]').fadeOut(200);
    $('[data-project-slideout]').removeClass('open');
  });

  $('[data-slideout]').on('click', function(e) {
    e.preventDefault();
    $('[data-project-slideout-overlay]').fadeIn(200);
    $('[data-project-slideout]').addClass('open');
  });

  $('[data-accordion-item]').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('show');
    $(this).parent().find('.accordion-text').slideToggle(200);
  });

  const sliderElems = document.getElementsByClassName('slider');
  if (sliderElems.length > 0) {
    let i = 1;
    // for (const slider of sliderElems) {
    Array.from(sliderElems).forEach(function(slider) {
      console.log(slider);
      const swiperConfig = JSON.parse(slider.dataset.slider);
      slider.classList.add('swiper' + i);
      const sliderID = '.swiper' + i + ' .swiperjs';
      new Swiper(sliderID, swiperConfig);
      i++;
    });
  }
});

jQuery(document).ready(($) => {
  $('.map-exchange').on('click', function(e) {
    e.preventDefault();
    let location = $(this).attr('data-location');
    setMap(location);
  });


  if(window.location.hash.length > 0) {
    setMap(window.location.hash.substring(1));
  }
});

function setMap(location) {
  $('.map-area').removeClass('open');
  $('[data-location]').removeClass('active');
  $('[data-location="'+location+'"]').addClass('active');
  setTimeout(function(){
    $('[data-location]').trigger('mapChanged');
  }, 500);
}


/* $('.top-navigation__links a').on('mouseover', function() {
  console.log('hover');
  let item = $(this).parent().find('.sub-menu .active .sub-menu__links');
  let lol = $(this).parent().find('.sub-menu');
  let sidemenu = $(this).parent().find('.sub-menu__content__side-menu');
  // if (sidemenu.length > 0) {
    // let smh = sidemenu.height();
    console.log('tim', item.height());
    console.log('sm', sidemenu.height());
    if (item.height() > sidemenu.height()) {
      lol.height(item.height() + 'px');
    } else {
      lol.height(sidemenu.height() + 'px');
    }
  // } else {
  //   lol.height(item.height() + 'px');
  // }
}); */


// var externalLink;

// function link_is_external(link_element) {
//   return (link_element.host !== window.location.host);
// }

// $('a').each(function(e) {
//   if (link_is_external(this)) {
//     e.preventDefault();
//     externalLink = $(this).attr('href');
//     $('.extLightbox').addClass('open');

//     $('.goToExternal').click(function () {
//       window.location.href = externalLink;
//     });
//     $('.closeExternal').click(function () {
//       $('.extLightbox').removeClass('open');
//     });
//   }
// });



// WEBPACK FOOTER //
// ./scripts/main.js